// extracted by mini-css-extract-plugin
export var section = "scroll-module--section--1JCfa";